import moment from 'moment';

export const isToday = (date: Date | undefined): boolean => {
    if (moment.isDate(date) === false) {
        return false;
    }
    const checkedMoment = moment(date);
    return checkedMoment.isBetween(moment().startOf('day'), moment().endOf('day'), 'day', '[]');
};

export const isYesterday = (date: Date | undefined): boolean => {
    if (moment.isDate(date) === false) {
        return false;
    }
    const yesterday = moment().subtract(1, 'days');
    const checkedMoment = moment(date);
    return checkedMoment.isBetween(yesterday.startOf('day'), yesterday.endOf('day'), 'day', '[]');
};

export const isWithinLastWeek = (date: Date | undefined): boolean => {
    if (moment.isDate(date) === false) {
        return false;
    }
    const lastWeek = moment().subtract(7, 'days');
    const yesterday = moment().subtract(1, 'days');
    const checkedMoment = moment(date);
    return checkedMoment.isBetween(lastWeek.startOf('day'), yesterday.endOf('day'), 'day', '[]');
};

export const isWithinLastMonth = (date: Date | undefined): boolean => {
    if (moment.isDate(date) === false) {
        return false;
    }
    const lastMonth = moment().subtract(1, 'months');
    const yesterday = moment().subtract(1, 'days');
    const checkedMoment = moment(date);
    return checkedMoment.isBetween(lastMonth.startOf('day'), yesterday.endOf('day'), 'day', '[]');
};

export const isOlderThanOneMonth = (date: Date | undefined): boolean => {
    if (moment.isDate(date) === false) {
        return false;
    }
    const lastMonth = moment().subtract(1, 'months');
    const checkedMoment = moment(date);
    const beginingOfLastMonth = lastMonth.startOf('day');
    return checkedMoment.isBefore(beginingOfLastMonth);
};

export const getMinutesDifference = (date1: Date, date2: Date) => {
    const date1Ms = date1.getTime();
    const date2Ms = date2.getTime();
    const differenceMs = date2Ms - date1Ms;
    const minutesDifference = differenceMs / (1000 * 60);
    return minutesDifference;
};

export const getRemainingMinutes = (expireAt: Date) => {
    const totalMinutes = Math.round(getMinutesDifference(new Date(Date.now()), expireAt));
    return totalMinutes;
};

export const getRemainingTime = (expireAt: Date) => {
    const totalMinutes = Math.round(getMinutesDifference(new Date(Date.now()), expireAt));
    const minutes = Math.round(totalMinutes % 60);
    const totalHours = Math.round(totalMinutes / 60);
    const hours = Math.round(totalHours % 24);
    const days = Math.round(totalHours / 24);

    return `${days ? `${days}d` : ''} ${hours || days ? `${hours ?? 0}h` : ''}${minutes ? `${String(minutes).padStart(2, '0')}` : ''}`;
};

export const formatDateToDDMMYYYY = (date: Date | string | undefined): string => {
    if (!date) {
        return '<no date>';
    }
    try {
        const dateObj = date instanceof Date ? date : new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    } catch {
        return String(date);
    }
};

export const formatDateToDDMMYYYYHHMMSS = (date: Date | string | undefined): string => {
    if (!date) {
        return '<no date>';
    }
    try {
        const dateObj = date instanceof Date ? date : new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } catch {
        return String(date);
    }
};

export const formatDateToYYYYMMDDHHMMSS = (date: Date | string | undefined): string => {
    if (!date) {
        return '<no date>';
    }
    try {
        const dateObj = date instanceof Date ? date : new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch {
        return String(date);
    }
};
